import { createSelector } from 'reselect'
import { pick } from 'lodash'

export const newestFirstSelector = createSelector(
	(state) => state.tasks.tasksByID,
	(tasksByID) =>
		Object.values(tasksByID).sort((a, b) => {
			const dateA = new Date(a.when_created)
			const dateB = new Date(b.when_created)
			if (dateA < dateB) return 1
			if (dateA > dateB) return -1
			return 0
		}),
)

export const oldestFirstSelector = createSelector(
	(state) => state.tasks.tasksByID,
	(tasksByID) =>
		Object.values(tasksByID).sort((a, b) => {
			const dateA = new Date(a.when_created)
			const dateB = new Date(b.when_created)
			if (dateA > dateB) return 1
			if (dateA < dateB) return -1
			return 0
		}),
)

export const scheduledLatestSelector = createSelector(
	(state) => state.tasks.tasksByID,
	(tasksByID) =>
		Object.values(tasksByID).sort((a, b) => {
			const whenToSend = (letter) =>
				letter.send_email
					? letter.send_email.when_to_send
					: letter.send_sms
					? letter.send_sms.when_to_send
					: null
			const dateA = new Date(whenToSend(a))
			const dateB = new Date(whenToSend(b))
			if (dateA < dateB) return 1
			if (dateA > dateB) return -1
			return 0
		}),
)

export const scheduledOldestSelector = createSelector(
	(state) => state.tasks.tasksByID,
	(tasksByID) =>
		Object.values(tasksByID).sort((a, b) => {
			const whenToSend = (letter) =>
				letter.send_email
					? letter.send_email.when_to_send
					: letter.send_sms
					? letter.send_sms.when_to_send
					: null
			const dateA = new Date(whenToSend(a))
			const dateB = new Date(whenToSend(b))
			if (dateA > dateB) return 1
			if (dateA < dateB) return -1
			return 0
		}),
)

export const mostOpensSelector = createSelector(
	(state) => state.tasks.tasksByID,
	(tasksByID) =>
		Object.values(tasksByID).sort((a, b) => {
			const opens = (letter) =>
				letter.email_stats && letter.email_stats.total_opens
					? letter.email_stats.total_opens
					: letter.sms_stats && letter.sms_stats.total_opens
					? letter.sms_stats.total_opens
					: 0
			if (opens(a) < opens(b)) return 1
			if (opens(a) > opens(b)) return -1
			return 0
		}),
)

export const mostSendsSelector = createSelector(
	(state) => state.tasks.tasksByID,
	(tasksByID) =>
		Object.values(tasksByID).sort((a, b) => {
			const sends = (letter) =>
				letter.email_stats && letter.email_stats.total_sends
					? letter.email_stats.total_sends
					: letter.sms_stats && letter.sms_stats.total_sends
					? letter.sms_stats.total_sends
					: 0
			if (sends(a) < sends(b)) return 1
			if (sends(a) > sends(b)) return -1
			return 0
		}),
)

export const mostClicksSelector = createSelector(
	(state) => state.tasks.tasksByID,
	(tasksByID) =>
		Object.values(tasksByID).sort((a, b) => {
			const clicks = (letter) =>
				letter.email_stats && letter.email_stats.total_clicks
					? letter.email_stats.total_clicks
					: 0
			if (clicks(a) < clicks(b)) return 1
			if (clicks(a) > clicks(b)) return -1
			return 0
		}),
)

// not all task types are currently implemented
export const currentlyUsedTaskTypesByIDSelector = createSelector(
	(state) => state.tasks.typesByID,
	(taskTypesByID) => pick(taskTypesByID, [
		'1', // send email
		'2', // send sms
		// '3', // push notification
		'4', // add contact to group
		'5', // remove contact from group
		'6', // move contact between groups
		'7', // reassign contact
		'8', // remove contact from campaign
		'9', // http post
		'10', // needs followup set
		'11', // needs followup clear
	]),
)

export const taskUneditableSelector = (state) => {
	const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
	const stats = task?.sms_stats || task?.email_stats
	const campaignStatus =
		state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
	const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
	const disabled = Boolean(
		(stats && automationTypeSelected !== 'stage') ||
			campaignStatus === 'L' ||
			campaignStatus === 'C',
	)

	return disabled
}
